
import { createClient } from '@supabase/supabase-js';
import { supabase as configuredSupabase } from '@/integrations/supabase/client';

// Use the properly configured Supabase client from the generated file
export const supabase = configuredSupabase;
